import {t} from '../../../common/getTranslations';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {Control} from '../../molecules/Control/Control';
import {ViewerSettingFontSizeProps} from './ViewerSettingFontSizeProps.interface';
import {ViewerSettingScrollableItem} from './ViewerSettingScrollableItem';

export function ViewerSettingFontSize({
  isMobile,
  currentFontSize,
  isFontSizeMinusDisabled = false,
  isFontSizePlusDisabled = false,
  onClickFontSizeMinus = () => {},
  onClickFontSizePlus = () => {},
}: ViewerSettingFontSizeProps) {
  return (
    <ViewerSettingScrollableItem
      isMobile={isMobile}
      title={t('viewer_setting_fontsize')}
      className={isMobile ? 'mt-6pxr' : 'mt-10pxr'}
    >
      <Control
        count={currentFontSize}
        onClickMinus={e =>
          LOG_CLICK_EVENT('글자크기_클릭', e, onClickFontSizeMinus)
        }
        onClickPlus={e =>
          LOG_CLICK_EVENT('글자크기_클릭', e, onClickFontSizePlus)
        }
        isMinusDisabled={isFontSizeMinusDisabled}
        isPlusDisabled={isFontSizePlusDisabled}
        isLoggingZoom
      />
    </ViewerSettingScrollableItem>
  );
}
